/**
 * Created by ricardocabret on 8/18/16.
 */
angular.module('multiChapterFilePlayerProvider.model', [

    //This provider all 'ONE' file User Audiobooks (M4B)

])
    .service('MultiChapterFilePlayer', ['WS', function (WS) {
        var model = this;

        model.isSample = false;

        function toSeconds(time) {
            return Math.floor(time / 1000);
        }

        model._getAudiobookPlaybackUrl = function (libraryAudiobookId) {
            return WS.callServer('download/getAudiobookPlaybackUrl/' + libraryAudiobookId, null)
        };

        model.initPlayer = function (eventCallbacksObj) {
            model._setupMcfPlayer(eventCallbacksObj);
        };

        model._setupMcfPlayer = function (eventCallbacksObj) {
            if (model.mcfPlayer != null && !model.mcfPlayer.paused) {
                model.mcfPlayer.pause();
                model.mcfPlayer.currentTime = 0;
            }
            model.mcfPlayer = new Audio;

            model.mcfPlayer.addEventListener("canplaythrough", function () {

                model.setCurrentTrackObj();
                eventCallbacksObj.handleOnLoad(model.mcfPlayer);
            }, false);

            model.mcfPlayer.addEventListener("timeupdate",
                function () {
                    var second = Math.floor(model.mcfPlayer.currentTime);
                    if (second % 1 == 0 && second && model.second != second) {
                        model.second = second;
                        if ((second - toSeconds(model.previousChaptersDuration)) == toSeconds(model.libraryAudiobook.progress.chapter.duration)) {
                            if (model.trackObj.index + 1 <= model.libraryAudiobook.audiobook.chapterList.length) {
                                eventCallbacksObj.handleTrackChanged(model.trackObj.index + 1);
                                model.previousChaptersDuration = model.getPreviousChaptersTime(model.trackObj.index + 1);
                            }
                        }

                        eventCallbacksObj.handleTimeChanged((second * 1000) - model.previousChaptersDuration);
                    }
                    //eventCallbacksObj.handleTimeChanged(model.mcfPlayer.currentTime * 1000 - model.previousChaptersDuration);
                }, false);

            model.mcfPlayer.addEventListener('ended', function () {
                eventCallbacksObj.handleOnEnd();
                model.mcfPlayer.currentTime = 0;
            });
        };

        model._loadMcfPlayer = function (url, callbackFunc) {
            if (!model.mcfPlayer) {
                return;
            }
            model.mcfPlayer.src = url;

            if (callbackFunc) {
                callbackFunc();
            }
        };

        model.play = async (libraryAudiobook, isSample, trackObj, position, callbackFunc) => {
            model.libraryAudiobook = libraryAudiobook;
            const response = await model._getAudiobookPlaybackUrl(libraryAudiobook.id);
            if (response && response.responseStatus === 'SUCCESS') {
                model._loadMcfPlayer(response.url,  () => {
                    if (callbackFunc) {
                        callbackFunc(response);
                    }

                    model.setCurrentTrackObj();
                    model.mcfPlayer.currentTime = toSeconds(model.previousChaptersDuration + position);
                    model.mcfPlayer.play().then();
                });
            }
        };

        model.setCurrentTrackObj = function () {
            model.trackObj = model.getCurrentChapterObj(model.libraryAudiobook.audiobook.chapterList, model.libraryAudiobook.progress.chapter.id);
            model.previousChaptersDuration = model.getPreviousChaptersTime(model.trackObj.index);
        };

        model.getCurrentTime = function () {
            if (!model.mcfPlayer) {
                return;
            }
            var currentTime = Math.max(0, (model.mcfPlayer.currentTime * 1000) - model.previousChaptersDuration);
            return currentTime;
        };

        model.resumePlay = function () {
            if (!model.mcfPlayer) {
                return;
            }
            model.mcfPlayer.play();
        };

        model.pause = function () {
            if (!model.mcfPlayer) {
                return;
            }
            model.mcfPlayer.pause();
        };

        model.skipToTrack = function (libraryAudiobook, trackObj, callbackFunc) {
            if (callbackFunc) {
                callbackFunc();
                model.setCurrentTrackObj();
                model.mcfPlayer.currentTime = toSeconds(model.previousChaptersDuration);
            }
        };

        model.seekTo = function (time) {
            if (!model.mcfPlayer) {
                return;
            }
            model.mcfPlayer.currentTime = toSeconds(model.previousChaptersDuration + time);
        };

        model.setVolume = function (value) {
            if (!model.mcfPlayer) {
                return;
            }
            model.mcfPlayer.volume = value / 100;
        };

        model.mutePlayer = function () {
            if (!model.mcfPlayer) {
                return;
            }
            model.mcfPlayer.volume = 0;
        };

        model.getCurrentChapterObj = function (chapterList, currentChapterId) {
            for (var i = 0; i < chapterList.length; i++) {
                if (chapterList[i].id == currentChapterId) {
                    return {chapterObj: chapterList[i], index: i};
                }
            }
        };

        model.getPreviousChaptersTime = function (chapterIndex) {
            var result = 0;
            if (model.libraryAudiobook.audiobook.chapterList.length > 1 && chapterIndex > 0) {
                for (var i = 0; i < chapterIndex; i++) {
                    result += model.libraryAudiobook.audiobook.chapterList[i].duration;
                }
            }
            return result;
        };


    }]);


